import React, { useCallback } from "react";
import { twJoin } from "tailwind-merge";

export interface ToastWrapperProps {
  id: string;
  className?: string;
  style?: React.CSSProperties;
  onHeightUpdate: (id: string, height: number) => void;
  children?: React.ReactNode;
}

export const ToastWrapper = ({ id, className, style, onHeightUpdate, children }: ToastWrapperProps) => {
  const ref = useCallback(
    (el: HTMLElement | null) => {
      if (el) {
        const updateHeight = () => {
          const height = el.getBoundingClientRect().height;
          onHeightUpdate(id, height);
        };

        updateHeight();

        new MutationObserver(updateHeight).observe(el, {
          subtree: true,
          childList: true,
          characterData: true,
        });
      }
    },
    [id, onHeightUpdate]
  );

  return (
    <div ref={ref} className={twJoin("sup-toast-wrap", className)} style={style}>
      {children}
    </div>
  );
};
